/**
 * マスタ共通関数
 *
 * @author hayakawa 2025.04.23
 */

// インポート
import { $spinner, employee_auth_id_admin, employee_work_type_part, option_dtpk_with_position } from '../_constants';
import { getNowDate } from '../_functions';

// 定数
const $flash_message = $('#flash-message'),                             // 実行結果表示場所
    $form_store_company = $('#form-store-company'),                     // 企業追加フォーム
    $form_update_company = $('#form-update-company'),                   // 企業更新フォーム
    $form_delete_company = $('#form-delete-company'),                   // 企業削除フォーム
    $form_store_organization = $('#form-store-organization'),           // 店舗追加フォーム
    $form_update_organization = $('#form-update-organization'),         // 店舗更新フォーム
    $form_delete_organization = $('#form-delete-organization'),         // 店舗削除フォーム
    $form_store_employee = $('#form-store-employee'),                   // 従業員追加フォーム
    $form_update_employee = $('#form-update-employee'),                 // 従業員更新フォーム
    $form_delete_employee = $('#form-delete-employee'),                 // 従業員削除フォーム
    $modal_employee_organization = $('#modal-employee-organization'),   // 所属店舗モーダル
    $modal_employee_hourly_wage = $('#modal-employee-hourly-wage'),     // 時給モーダル
    author_auth_id = $('#author-auth-id').val();                        // ユーザー権限ID

/**
 * 企業追加・修正・削除
 *
 * @param {object} button_object
 * @returns {void}
 * @author hayakawa 2023.10.17
 */
export const submitCompany = (button_object) => {
    const is_add = (button_object.attr('id') === 'btn-add-company') ? true : false,
        is_update = (button_object.attr('id') === 'btn-update-company') ? true : false,
        is_delete = (button_object.attr('id') === 'btn-delete-company') ? true : false,
        api_endpoint = (is_add) ? VALIDATE_STORE_COMPANY_API_ENDPOINT : ((is_update) ? VALIDATE_UPDATE_COMPANY_API_ENDPOINT : VALIDATE_DELETE_COMPANY_API_ENDPOINT),
        $form = (is_add) ? $form_store_company : ((is_update) ? $form_update_company : $form_delete_company),
        $form_data = new FormData($form.get(0)),
        params = new URLSearchParams($form_data),
        $btn = $('button'),
        btn_html = button_object.html();

    $btn.prop('disabled', true);
    button_object.html($spinner);
    axios.get(`${api_endpoint}?${params.toString()}`)
    .then(res => {
        $flash_message.find('.exec-result-message').html('').hide();
        $('.is-invalid').removeClass('is-invalid');
        $('.invalid-feedback').text('');
        let ret = (is_delete) ? confirm('削除してよろしいですか？') : true;
        if (ret) {
            $form.trigger('submit');
        }
    })
    .catch(err => {
        const errors = err.response.data.errors;
        let html = `<ul>\n`;

        $flash_message.find('.exec-result-message').html('').hide();
        $('.is-invalid').removeClass('is-invalid');
        $('.invalid-feedback').text('');
        $.each(errors, function(k, v) {
            const id = $(`[name=${k}]`).attr('id');
            $(`[name=${k}]`).addClass('is-invalid');
            $(`[name=${k}]`).next().text(v);
            if (id === undefined) {
                html += `<li>${v}</li>\n`;
            } else {
                html += `<li><a href="#${id}" class="alert-link">${v}</a></li>\n`;
            }
        })
        html += `</ul>\n`;
        $flash_message.find('.exec-result-message').html(html).show();
    })
    .finally(() => {
        button_object.html(btn_html);
        $btn.prop('disabled', false);
    })
};

/**
 * 店舗追加・修正・削除
 *
 * @param {object} button_object
 * @returns {void}
 * @author hayakawa 2023.10.17
 */
export const submitOrganization = (button_object) => {
    const is_add = ($(button_object).attr('id') === 'btn-add-organization') ? true : false,
            is_update = ($(button_object).attr('id') === 'btn-update-organization') ? true : false,
            is_delete = ($(button_object).attr('id') === 'btn-delete-organization') ? true : false,
            api_endpoint = (is_add) ? VALIDATE_STORE_ORGANIZATION_API_ENDPOINT : ((is_update) ? VALIDATE_UPDATE_ORGANIZATION_API_ENDPOINT : VALIDATE_DELETE_ORGANIZATION_API_ENDPOINT),
            $form = (is_add) ? $form_store_organization : ((is_update) ? $form_update_organization : $form_delete_organization),
            $form_data = new FormData($form.get(0)),
            params = new URLSearchParams($form_data),
            $btn = $('button'),
            btn_html = $(button_object).html();

    $btn.prop('disabled', true);
    $(button_object).html($spinner);
    axios.get(`${api_endpoint}?${params.toString()}`)
    .then(res => {
        $flash_message.find('.exec-result-message').html('').hide();
        $('.is-invalid').removeClass('is-invalid');
        $('.invalid-feedback').text('');
        let ret = (is_delete) ? confirm('削除してよろしいですか？') : true;
        if (ret) {
            $form.trigger('submit');
        }
    })
    .catch(err => {
        const errors = err.response.data.errors;
        let html = `<ul>\n`;
        $flash_message.find('.exec-result-message').html('').hide();
        $('.is-invalid').removeClass('is-invalid');
        $('.invalid-feedback').text('');
        $.each(errors, function(k, v) {
            const id = $(`[name=${k}]`).attr('id');
            $(`[name=${k}]`).addClass('is-invalid');
            $(`[name=${k}]`).next().text(v);
            if (id === undefined) {
                html += `<li>${v}</li>\n`;
            } else {
                html += `<li><a href="#${id}" class="alert-link">${v}</a></li>\n`;
            }
        })
        html += `</ul>\n`;
        $flash_message.find('.exec-result-message').html(html).show();
    })
    .finally(() => {
        button_object.html(btn_html);
        $btn.prop('disabled', false);
    })
};

/**
 * 従業員追加・修正・削除
 *
 * @param {object} button_object
 * @returns {void}
 * @author hayakawa 2023.10.17
 */
export const submitEmployee = (button_object) => {
    const is_add = (button_object.attr('id') === 'btn-add-employee') ? true : false,
        is_update = (button_object.attr('id') === 'btn-update-employee') ? true : false,
        is_delete = (button_object.attr('id') === 'btn-delete-employee') ? true : false,
        is_reset = (is_update && $form_update_employee.find('[name=initial_flag]').prop('checked')) ? true : false,
        api_endpoint = (is_add) ? VALIDATE_STORE_EMPLOYEE_API_ENDPOINT : ((is_update) ? VALIDATE_UPDATE_EMPLOYEE_API_ENDPOINT : VALIDATE_DELETE_EMPLOYEE_API_ENDPOINT),
        $form = (is_add) ? $form_store_employee : ((is_update) ? $form_update_employee : $form_delete_employee),
        mail_address = $form.find('[name="employee_email"]').val(),
        $form_data = new FormData($form.get(0)),
        params = new URLSearchParams($form_data),
        $btn = $('button'),
        btn_html = button_object.html();

    $btn.prop('disabled', true);
    button_object.html($spinner);
    axios.get(`${api_endpoint}?${params.toString()}`)
    .then(res => {
        $flash_message.find('.exec-result-message').html('').hide();
        $('.is-invalid').removeClass('is-invalid');
        $('.invalid-feedback').text('');
        let ret_email = true;
        if (mail_address === '') {
            ret_email = confirm("メールアドレスが入力されていません。\nForceアプリのダウンロードにはメールアドレスの入力が必要です。\nこのまま登録してもよろしいですか？");
        }
        if (ret_email) {
            let ret = (is_delete) ? confirm('削除してよろしいですか？') : ((is_reset) ? confirm('パスワードをリセットして更新してよろしいですか？') : true);
            if (ret) {
                $form.trigger('submit');
            }
        }
    })
    .catch(err => {
        const errors = err.response.data.errors;
        let html = `<ul>\n`;
        $('.is-invalid').removeClass('is-invalid');
        $('.invalid-feedback').text('');
        $.each(errors, function(k, v) {
            const id = $(`[name=${k}]`).attr('id');
            $(`[name=${k}]`).addClass('is-invalid');
            $(`[name=${k}]`).next().text(v);
            if (id === undefined) {
                html += `<li>${v}</li>\n`;
            } else {
                html += `<li><a href="#${id}" class="alert-link">${v}</a></li>\n`;
            }
        })
        html += `</ul>\n`;
        $flash_message.find('.exec-result-message').html(html).show();
    })
    .finally(() => {
        button_object.html(btn_html);
        $btn.prop('disabled', false);
    })
};

/**
 * 共通 モーダルコンテンツ 詳細行生成 (所属店舗)
 *
 * @param {string} mode
 * @param {array} arr
 * @returns {void}
 * @author hayakawa 2025.04.23
 */
export const cloneEmployeeOrganization = (mode, arr) => {
    const len = arr.length,
        cnt = Number($('#btn-append-employee-organization').attr('data-count'));
    let html = '';

    if (len === 0) {
        const employee_work_type = $('[name="work_type"]').val(),
            $tr = $('#append-source-employee-organization').clone(true),
            company_id = '0',
            organization_id = `new-${cnt}`;

        let next_day = '';

        // アルバイトの場合は初期値を設定する（直前のto_dateの次の日をfrom_dateに入れる）
        if (Number(employee_work_type) === employee_work_type_part) {
            let max_value = '';
            $modal_employee_organization.find('tbody').find('input[name="to_date[]"]').each(function(index) {
                if (max_value < $(this).val()) {
                    max_value = $(this).val();
                }
            });

            if (max_value !== '') {
                let max_date = new Date(max_value);
                max_date.setDate(max_date.getDate() + 1);
                next_day = `${max_date.getFullYear()}/${String(max_date.getMonth() + 1).padStart(2, '0')}/${String(max_date.getDate()).padStart(2, '0')}`;
            }
        }

        $tr.removeAttr('id').removeClass('d-none');
        $tr.find('#div-eo-from-date-').attr('id', `div-eo-from-date-${organization_id}`);
        $tr.find('#eo-from-date-').attr('id', `eo-from-date-${organization_id}`).attr('data-target', `#div-eo-from-date-${organization_id}`).attr('value', next_day).prop('disabled', false);
        $tr.find('div[data-target="#div-eo-from-date-"]').attr('data-target', `#div-eo-from-date-${organization_id}`);
        $tr.find('#div-eo-to-date-').attr('id', `div-eo-to-date-${organization_id}`);
        $tr.find('#eo-to-date-').attr('id', `eo-to-date-${organization_id}`).attr('data-target', `#div-eo-to-date-${organization_id}`).prop('disabled', false);
        $tr.find('div[data-target="#div-eo-to-date-"]').attr('data-target', `#div-eo-to-date-${organization_id}`);
        $tr.find('input[type="hidden"][name="organization_id[]"]:disabled').prop('disabled', false);
        //$tr.find('#organization-id-').attr('id', `organization-id-${organization_id}`).attr('data-company_id', company_id).attr('data-organization_id', organization_id).prop('disabled', false);
        $tr.find('.btn-delete-employee-organization').prop('disabled', false);
        $tr.find('button.btn-show-employee-organization-group').attr('id', `organization-id-${organization_id}`).attr('data-selected_company_id', company_id).attr('data-selected_organization_id', organization_id).prop('disabled', false);
        html += $tr.prop('outerHTML');
        if (mode === 'show') {
            $modal_employee_organization.find('tbody').html(html);
        } else {
            $modal_employee_organization.find('tbody').append(html);
        }
        $('#btn-append-employee-organization').attr('data-count', cnt + 1);
    } else {
        $.each(arr, function(k, v) {
            const $tr = $('#append-source-employee-organization').clone(true),
                company_id = String(v.company_id),
                organization_id = String(v.organization_id),
                now_date = getNowDate(),
                is_disabled = Number(author_auth_id) !== employee_auth_id_admin && v.to_date_str !== '' && v.to_date_str < now_date;

            $tr.removeAttr('id').removeClass('d-none');
            $tr.find('#div-eo-from-date-').attr('id', `div-eo-from-date-${k}`);
            $tr.find('#eo-from-date-').attr('id', `eo-from-date-${k}`).attr('data-target', `#div-eo-from-date-${k}`).attr('value', v.from_date_str).prop('disabled', false);
            $tr.find('div[data-target="#div-eo-from-date-"]').attr('data-target', `#div-eo-from-date-${k}`);
            $tr.find('#div-eo-to-date-').attr('id', `div-eo-to-date-${k}`);
            $tr.find('#eo-to-date-').attr('id', `eo-to-date-${k}`).attr('data-target', `#div-eo-to-date-${k}`).attr('value', v.to_date_str).prop('disabled', false);
            $tr.find('div[data-target="#div-eo-to-date-"]').attr('data-target', `#div-eo-to-date-${k}`);
            $tr.find('input[type="hidden"][name="organization_id[]"]:disabled').attr('value', organization_id).prop('disabled', false);
            //$tr.find('#organization-id-').attr('id', `organization-id-${k}`).attr('data-company_id', company_id).attr('data-organization_id', organization_id).text(v.organization_name).removeClass('placeholder').prop('disabled', false);
            $tr.find('.btn-delete-employee-organization').prop('disabled', false);
            $tr.find('button.btn-show-employee-organization-group').attr('id', `organization-id-${k}`).attr('data-selected_company_id', company_id).attr('data-selected_organization_id', organization_id).text(v.organization_name).removeClass('placeholder').prop('disabled', false);
            if (is_disabled) {
                $tr.find(`#eo-from-date-${k}`).prop('disabled', true).addClass('disabled');
                $tr.find(`#eo-to-date-${k}`).prop('disabled', true).addClass('disabled');
                $tr.find('button.btn-delete-employee-organization').prop('disabled', true).addClass('disabled');
                $tr.find('button.btn-show-employee-organization-group').prop('disabled', true).addClass('disabled');
            }

            html += $tr.prop('outerHTML');
        });
        $modal_employee_organization.find('tbody').html(html);
    }

    $modal_employee_organization.find('.dtpk.ymd-slash').datetimepicker(option_dtpk_with_position);
}

/**
 * 共通 モーダルコンテンツ 詳細行生成 (時給)
 *
 * @param {string} mode
 * @param {array} arr
 * @returns {void}
 * @author hayakawa 2023.10.17
 */
export const cloneEmployeeHourlyWage = (mode, arr) => {
    const len = arr.length,
        cnt = Number($('#btn-append-employee-hourly-wage').attr('data-count'));

    let html = '';
    if (len === 0) {
        const $tr = $('#append-source-employee-hourly-wage').clone(true),
            employee_hourly_wage_id = `new-${cnt}`;

        $tr.removeAttr('id').removeClass('d-none');
        $tr.find('#div-ehw-from-date-').attr('id', `div-ehw-from-date-${employee_hourly_wage_id}`);
        $tr.find('#ehw-from-date-').attr('id', `ehw-from-date-${employee_hourly_wage_id}`).attr('data-target', `#div-ehw-from-date-${employee_hourly_wage_id}`).prop('disabled', false);
        $tr.find('div[data-target="#div-ehw-from-date-"]').attr('data-target', `#div-ehw-from-date-${employee_hourly_wage_id}`);
        $tr.find('#div-ehw-to-date-').attr('id', `div-ehw-to-date-${employee_hourly_wage_id}`);
        $tr.find('#ehw-to-date-').attr('id', `ehw-to-date-${employee_hourly_wage_id}`).attr('data-target', `#div-ehw-to-date-${employee_hourly_wage_id}`).prop('disabled', false)
        $tr.find('div[data-target="#div-ehw-to-date-"]').attr('data-target', `#div-ehw-to-date-${employee_hourly_wage_id}`);
        $tr.find('#hourly-wage-').attr('id', `hourly-wage-${employee_hourly_wage_id}`).prop('disabled', false);
        $tr.find('.btn-delete-employee-hourly-wage').prop('disabled', false);
        html += $tr.prop('outerHTML');
        if (mode === 'show') {
            $modal_employee_hourly_wage.find('tbody').html(html);
        } else {
            $modal_employee_hourly_wage.find('tbody').append(html);
        }
        $('#btn-append-employee-hourly-wage').attr('data-count', cnt + 1);
    } else {
        $.each(arr, function(k, v) {
            const $tr = $('#append-source-employee-hourly-wage').clone(true),
                employee_hourly_wage_id = String(v.employee_hourly_wage_id);

            $tr.removeAttr('id').removeClass('d-none');
            $tr.find('#div-ehw-from-date-').attr('id', `div-ehw-from-date-${employee_hourly_wage_id}`);
            $tr.find('#ehw-from-date-').attr('id', `ehw-from-date-${employee_hourly_wage_id}`).attr('data-target', `#div-ehw-from-date-${employee_hourly_wage_id}`).attr('value', v.from_date_str).prop('disabled', false)
            $tr.find('div[data-target="#div-ehw-from-date-"]').attr('data-target', `#div-ehw-from-date-${employee_hourly_wage_id}`);
            $tr.find('#div-ehw-to-date-').attr('id', `div-ehw-to-date-${employee_hourly_wage_id}`);
            $tr.find('#ehw-to-date-').attr('id', `ehw-to-date-${employee_hourly_wage_id}`).attr('data-target', `#div-ehw-to-date-${employee_hourly_wage_id}`).attr('value', v.to_date_str).prop('disabled', false)
            $tr.find('div[data-target="#div-ehw-to-date-"]').attr('data-target', `#div-ehw-to-date-${employee_hourly_wage_id}`);
            $tr.find('#hourly-wage-').attr('id', `hourly-wage-${employee_hourly_wage_id}`).attr('value', v.hourly_wage_num).prop('disabled', false);
            $tr.find('.btn-delete-employee-hourly-wage').prop('disabled', false);
            html += $tr.prop('outerHTML');
        });
        $modal_employee_hourly_wage.find('tbody').html(html);
    }

    $modal_employee_hourly_wage.find('.dtpk.ymd-slash').datetimepicker(option_dtpk_with_position);
};

/**
 * 18歳未満フラグを設定
 *
 * @param {string} birthday
 * @returns {void}
 * @author hayakawa 2023.10.17
 */
export const setUnder18Flag = (birthday) => {
    const today = new Date(Date.now()),
        u18_y = today.getFullYear() - 18,
        u18_m = today.getMonth() + 1,
        u18_d = today.getDate(),
        u18_date = new Date(u18_y, u18_m, u18_d, 0, 0, 0),
        birthdays = birthday.split('/'),
        bd_y = birthdays[0],
        bd_m = birthdays[1],
        bd_d = birthdays[2],
        bd_date = new Date(bd_y, bd_m, bd_d, 0, 0, 0),
        is_under_18 = (u18_date < bd_date) ? true : false;

    if (is_under_18) {
        $('[data-group="under-18-flag"][data-param="on"]').trigger('click');
        $('[data-group="under_18_flag"][data-param="on"]').trigger('click');
    } else {
        $('[data-group="under-18-flag"][data-param="off"]').trigger('click');
        $('[data-group="under_18_flag"][data-param="off"]').trigger('click');
    }
};
